import { render, staticRenderFns } from "./BracketStage.vue?vue&type=template&id=291d7a69&scoped=true&"
import script from "./BracketStage.vue?vue&type=script&lang=js&"
export * from "./BracketStage.vue?vue&type=script&lang=js&"
import style0 from "./BracketStage.vue?vue&type=style&index=0&id=291d7a69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d7a69",
  null
  
)

export default component.exports